import { Icon } from "@iconify/react";

import React from "react";
import "./TechRobotBanner.css";
const TechRobotBanner = (props) => {
  return (
    <div>
      <section className="techRobotBanner">
        <div className="container">
          <div className="techRobotBanner-content">
            <div className="row ">
              <div className="col-xl-8 col-12 tech-banner-left">
                <div className="row w-100">
                  <div className="col-lg-4 col-12 leftimg">
                    <div className="techRobotNft">
                      <img src={props.forImage} alt="" />
                    </div>
                  </div>

                  <div className="col-lg-8 col-12">
                    <div className="tech-detail ">
                      <div className="techRobotHead">
                        <h1>Tech Robot</h1>
                      </div>

                      <div className=" item-details">
                        <div className="row  listed-item">
                          <div className="col-md-5 col-12 physical-item">
                            <p>Physical Items listed</p>
                            <h4>2,000</h4>
                          </div>
                          <div className="col-md-1 col-12"></div>
                          <div className="col-md-5 col-12 digital-item">
                            <p>Digital Items listed</p>
                            <h4>2,000</h4>
                          </div>
                        </div>

                        <div className="row item-vol">
                          <div className="col-md-5 col-12 physical-item">
                            <p>Vol SOL</p>
                            <h4>2.5SOL</h4>
                          </div>
                          <div className="col-md-1 col-12"></div>
                          <div className="col-md-5 col-12 physical-item">
                            <p>Native SLP Token</p>
                            <h4>100</h4>
                          </div>
                        </div>

                        <div className="row item-Sold">
                          <div className="col-md-5 col-12 physical-item">
                            <p>Vol SOL</p>
                            <h4>2.5SOL</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md col-12"></div> */}

              <div className="col-xl-4 col-12 tech-banner-right">
                <div className="techRobot-social-icon">
                  <div className="web-link">
                    <Icon icon="pepicons:internet" height={24} color="white" />
                  </div>

                  <div className="twitter-follower">
                    <Icon
                      icon="ant-design:twitter-outlined"
                      height={24}
                      color="white"
                    />
                    <p>12.3k</p>
                  </div>
                  <div className="discord-link">
                    <Icon
                      icon="akar-icons:discord-fill"
                      height={24}
                      color="white"
                    />
                  </div>
                  <div className="total-view">
                    <Icon icon="ph:binoculars-fill" height={24} color="white" />

                    <p>12.3k</p>
                  </div>
                </div>
                <div className="techRobot-detail">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Arcu, id augue quis at et duis lacus posuere. Venenatis
                    dolor in justo pulvinar urna, faucibus purus pretium
                    rhoncus. Maecenas nunc eu nisl condimentum consectetur
                    adipiscing rutrum tortor euismod. Nunc mattis quam proin
                    mauris. In risus porta egestas semper ac nibh. Lorem ipsum
                    dolor sit amet, consectetur adipiscing elit. Arcu, id augue
                    quis at et duis lacus posuere. Venenatis dolor in justo
                    pulvinar urna, faucibus purus pretium rhoncus. Maecenas nunc
                    eu nisl condimentum consectetur adipiscing rutrum tortor
                    euismod. Nunc mattis quam proin mauris. In risus porta
                    egestas semper ac nibh
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechRobotBanner;
